import React from 'react'
import has from 'lodash/has'
import upperFirst from 'lodash/upperFirst'
import isArray from 'lodash/isArray'

import NotFound from './NotFound'

import EventsList from './Events/EventsList'
import PopularEvents from './Events/PopularEvents'
import EventsCategories from './Events/EventsCategories'

const subList = {
  EventsList: <EventsList />,
  PopularEvents: <PopularEvents />,
  EventsCategories: <EventsCategories />
}

const SubComponent = ({subname = 'list'}) => {
  let index = subname
  index = index.split('-')
  if (!isArray(index)) {
    index = upperFirst(index)
  } else {
    index = index.map((el) => upperFirst(el))
    index = index.join('')
  }

  if (has(subList, index)) {
    return subList[index]
  } else {
    return <NotFound />
  }
}

const EventsPage = ({location, match}) => <SubComponent subname={match.params.sub} location={location}/>

export default EventsPage



// WEBPACK FOOTER //
// ./src/Pages/EventsPage.js